import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Meta, Title} from '@angular/platform-browser';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements AfterViewInit, OnInit {
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    @ViewChild('contenedorMovil') contentMovil: ElementRef;
    public faqs = [
        {
            question: 'Como enviar um documento para assinatura com FAD®?',
            description: 'Aqui te mostramos como… <a href="https://www.youtube.com/watch?v=ab2c8ozjkZA" target="_blank">Clique aqui.</a>'
        },
        {
            question: 'Como assinar um documento com FAD®?',
            description: 'Aqui te mostramos como… <a href="https://www.youtube.com/watch?v=VFMa9_BmvlA" target="_blank">Clique aqui.</a>'
        },
        {
            question: 'A assinatura de documentos através do FAD® tem a mesma validade da assinatura em papel?',
            description: 'A legislação considera a Assinatura Autógrafa Digital® como o equivalente funcional de uma assinatura em papel, utilizando os “meios eletrônicos como veículos para dar segurança às partes no contrato. Assim, FAD® é uma assinatura manuscrita que se reflete em dispositivo eletrônico, perfeitamente válida como meio de prova de consentimento, ainda que seja exigida a forma escrita, tendo assim pleno valor jurídico.'
        },
        {
            question: 'Que documentos posso assinar com o FAD®?',
            description: 'Com o FAD® você pode assinar contratos, notas promissórias, recibos, pedidos e muito mais. FAD® permite a assinatura de qualquer tipo de documento que requeira segurança jurídica em ambientes móveis e digitais. Para mais informações, visite: <a href="https://blog.firmaautografa.com/mil-e-uma-formas-de-usar-a-assinatura-autografa-digital">Ver mais casos de uso.</a>'
        },
        {
            question: 'Preciso de internet para usar o FAD®?',
            description: 'É necessária uma conexão à Internet para obter o documento a ser assinado, uma vez dentro do aplicativo você poderá assinar offline e sua assinatura no documento será enviada assim que sua conexão à Internet for restabelecida.'
        },
        {
            question: 'Posso assinar offline (sem Internet)?',
            description: 'Sim, depois de ter o documento para assinar no aplicativo móvel FAD®, você poderá assinar sem Internet. Por exemplo, você pode assinar enquanto estiver viajando de avião e enviar os documentos assinados, assim que chegar ao seu destino, o documento é enviado quando a conexão for restabelecida.'
        },
        {
            question: 'Todas as pessoas envolvidas no documento podem assinar no mesmo smartphone?',
            description: 'Sim, com FAD® todos os signatários podem assinar no mesmo dispositivo.'
        },
        {
            question: 'Os envolvidos podem assinar um documento em diferentes smartphones?',
            description: 'Sim, com o FAD® os envolvidos podem assinar de seus smartphones, independentemente de estarem em localizações geográficas diferentes.'
        },
        {
            question: 'É seguro assinar usando FAD®?',
            description: 'O FAD® é mais seguro que o papel graças aos diferentes elementos tecnológicos aplicados no documento e na solução (elementos de identificação multimídia, códigos de verificação e constância de conservação, criptografia de informações, etc.). Para mais informações, visite: <a href="https://www.assinaturaautografadigital.com.br/conformidade-legal-da-assinatura-digital">Conformidade</a>'
        },
        {
            question: 'Onde são armazenados os documentos assinados com FAD®?',
            description: 'FAD®  não armazena nenhum documento assinado, o usuário é responsável por armazenar os arquivos gerados no processo de assinatura.'
        },
        {
            question: 'Quais são os modelos de compra para adquirir o FAD®?',
            description: 'Você pode adquirir FAD® por um pacote de transações ou por um plano de assinatura mensal, com o qual você pode assinar sem limites. Para obter mais informações, entre em contato conosco em: <a href="https://www.assinaturaautografadigital.com.br/como-comecar-a-assinar-digitalmente" ">Contato</a>'
        },
        {
            question: 'Como faço o download do aplicativo móvel FAD®?',
            description: 'Ao finalizar a configuração do documento a ser assinado, é enviado um link por SMS para o download do aplicativo FAD® mobile.'
        },
        {
            question: 'O documento é salvo no smartphone após assiná-lo?',
            description: 'Não. O banco de dados é removido do dispositivo sem deixar rastros.'
        },
        {
            question: 'O documento pode ser modificado após ter sido assinado e enviado ao (s) signatário (s) durante o processo de assinatura?',
            description: 'Não, o FAD® utiliza diversos mecanismos de segurança, empregando comunicação segura através do uso de TLS, enviando as informações criptografadas e com hash de verificação de autenticidade.'
        },
        {
            question: 'Para que serve a Constante de Conservação?',
            description: 'Os documentos assinados com FAD® ficam armazenados nos nossos servidores TEMPORARIAMENTE - 30 dias após a sua assinatura, ao mesmo tempo que os enviamos aos repositórios que designou para tal.\n' +
                '<br>- Provas legais de integridade e inalterabilidade em um documento em caso de controvérsia;\n' +
                '<br>- Conformidade com mudanças legais;\n' +
                '<br>- A hora exata em que um documento eletrônico foi gerado.\n'
        },
        {
            question: 'Como tenho certeza de que a operação de assinatura não pode ser alterada e / ou modificada?',
            description: 'O FAD® fornece um conjunto irrefutável de evidências por meio de uma impressão digital de auditoria composta por 13 elementos, alguns dos quais são:\n' +
                '<br>- Autógrafo manuscrito do signatário.\n' +
                '<br>- Vídeo que registra a ação autografada do signatário e da pessoa que assina simultaneamente.\n' +
                '<br>- Vídeo de aceitação do acordo adquirido pelo signatário.\n'
        },
        {
            question: 'Quais são as principais características do sistema?',
            description: 'Com o FAD® você pode vincular seu repositório ou sistema de gerenciamento de documentos e configurar as áreas onde os envolvidos irão assinar, posteriormente você pode enviar por SMS o link para baixar o aplicativo móvel nas lojas e instalá-lo, bem como um código QR ou link que conterá o documento a ser assinado.'
        },
        {
            question: 'Caso tenha algum detalhe com o funcionamento do FAD®, tenho suporte?',
            description: 'Sim, você terá suporte via e-mail, whatsapp, tel, com resposta em menos de 24 horas.'
        },
        {
            question: 'E as atualizações do FAD® após a compra?',
            description: 'Você contará com todas as atualizações que nossa equipe de desenvolvimento continuará implementando para o aprimoramento constante do FAD®.'
        }
    ];

    constructor(
        private deviceService: DeviceDetectorService,
        private metas: Meta,
        private titlePage: Title
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        const TITLE = 'Perguntas frequentes sobre a assinatura digital FAD® | A única Assinatura Autógrafa Digital®';
        const DESCRIPTION = 'Cuidar de seus dados é importante para nós, conheça nosso aviso de privacidade. Qualquer dúvida ou reclamação entre em contato conosco em privacy@na-at.com.mx';
        const URL = 'https://www.assinaturaautografadigital.com.br/perguntas-frequentes-da-assinatura-digital-fad';
        const IMG = 'https://hola.firmaautografa.com/hubfs/BRASIL-ASSETS/METAS-PLACE-BRASIL-PAGES/faqs.png';
        this.titlePage.setTitle(TITLE);
        /* PRINCIPALES */
        this.metas.updateTag({
            name: 'keywords',
            content: 'como firmar un documento digitalmente, como firmar un documento en pdf'
        });
        this.metas.updateTag({
            name: 'description',
            content: DESCRIPTION
        });
        /* FACEBOOK Y LINKEDIN */
        this.metas.updateTag({
            property: 'og:url',
            content: URL
        });
        this.metas.updateTag({
            property: 'og:title',
            content: TITLE
        });
        this.metas.updateTag({
            property: 'og:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            property: 'og:image',
            content: IMG
        });
        /* TWITTER */
        this.metas.updateTag({
            name: 'twitter:title',
            content: TITLE
        });
        this.metas.updateTag({
            name: 'twitter:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            name: 'twitter:image',
            content: IMG
        });
        window.scrollTo(0, 0);
    }

    ngAfterViewInit(): void {
    }

    ngOnInit(): void {
    }

}
